var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "calculator",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 468 468",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_787_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M426.279,0H41.721C18.716,0,0,18.716,0,41.721V426.28C0,449.284,18.716,468,41.721,468H426.28 c23.004,0,41.72-18.716,41.72-41.721V41.721C468,18.716,449.284,0,426.279,0z M438,426.279c0,6.463-5.258,11.721-11.721,11.721 H41.721C35.258,438,30,432.742,30,426.279V41.721C30,35.258,35.258,30,41.721,30H426.28c6.462,0,11.72,5.258,11.72,11.721 V426.279z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.471,128.813h-38.997V89.815c0-8.284-6.716-15-15-15s-15,6.716-15,15v38.997H75.477c-8.284,0-15,6.716-15,15 s6.716,15,15,15h38.997v38.997c0,8.284,6.716,15,15,15s15-6.716,15-15v-38.997h38.997c8.284,0,15-6.716,15-15 S191.755,128.813,183.471,128.813z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.262,279.021c-5.857-5.857-15.355-5.857-21.213,0l-27.575,27.576l-27.575-27.576c-5.857-5.859-15.355-5.857-21.213,0 c-5.858,5.858-5.858,15.355,0,21.213l27.575,27.576l-27.575,27.576c-5.858,5.857-5.858,15.355,0,21.213 c2.929,2.929,6.768,4.393,10.606,4.393c3.839,0,7.678-1.465,10.606-4.393l27.575-27.576l27.575,27.576 c2.929,2.93,6.768,4.393,10.606,4.393c3.838,0,7.678-1.465,10.606-4.393c5.858-5.857,5.858-15.355,0-21.213l-27.575-27.576 l27.575-27.576C184.12,294.377,184.12,284.879,178.262,279.021z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.961,128.813H277.966c-8.284,0-15,6.716-15,15s6.716,15,15,15h107.995c8.284,0,15-6.716,15-15 C400.961,135.528,394.245,128.813,385.961,128.813z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.752,277.024c-5.857-5.859-15.355-5.858-21.213,0l-76.364,76.363c-5.858,5.857-5.858,15.355,0,21.213 c2.929,2.93,6.768,4.394,10.607,4.394c3.838,0,7.678-1.465,10.606-4.394l76.364-76.363 C386.61,292.38,386.61,282.882,380.752,277.024z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.866,
    cy: 291.904,
    r: 18.461
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.061,
    cy: 359.722,
    r: 18.461
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.0113ac62e59903bbe581471adf313bb1.svg";
export { ForwardRef as ReactComponent };